/*eslint-disable */
var $ = window.jQuery = jQuery = require('jquery');
import Quiz from '../../components/CourseQuiz/index';
import appFooter from '../../components/footer/index';
import root from '../../_helpers/roots';
import toast from '../../services/toast'
import axios from 'axios';
export default {
  name: 'course-quiz',
  components: {
    'app-footer': appFooter,
    'quiz-format': Quiz
  },
  data() {
    return {
      quizDetails: '',
      totalTime: 0,
      quizZ: {
        questions: []
      },
    }
  },
  computed: {

  },
  mounted() {
    $('.quizloader,.courseloader').hide();
    this.getCourseQuizDetails()
    $('body').addClass('user_quiz_popup_active');
  },
  methods: {
    getCourseQuizDetails: function() {
      $('.quizloader,.courseloader').show();
      let quizListUrlLink = root.quizDetailLink.link + this.$route.params.quizId + '/';
      axios.get(quizListUrlLink).then(response => {
        if (response.status === 200) {
          this.totalTime = response.data.data.time_limit;
          this.quizZ.questions = response.data.data.questions;
          this.quizDetails = response.data.data;
          console.log(this.quizDetails, "Quiz Details")
          $('.quizloader,.courseloader').hide();
        }
      }).catch(err => {
        toast.error(err.data.data.message);
        this.$router.go(-1);
        $('.quizloader,.courseloader').hide();
      })
    },
  userQuizClose(){
    this.$router.go(-1);
    $('.quizloader,.courseloader').hide();
    setTimeout(() => {
      $('body').removeClass('user_quiz_popup_active');
    }, 50);
  }
  },
  created() {

  },
  beforeCreate: function() {

  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('user_quiz_popup_active');
    next();
  },
}